/**
 * A floor plan on a feed listing can only be removed when Rental Manager created it through a feed override. Floor
 * plans the feed provided stay read-only, and the override is what carries the feedModelId the delete needs.
 */
export const getIsFeedFloorPlanDeletable = ({
  isFeed,
  isFeedOverride,
  feedModelId,
  isFeedOverrideSectionEnabled,
}: {
  isFeed: boolean;
  isFeedOverride?: boolean;
  feedModelId?: string;
  isFeedOverrideSectionEnabled: boolean;
}): boolean => isFeed && Boolean(isFeedOverride) && Boolean(feedModelId) && isFeedOverrideSectionEnabled;
